import { Injectable, OnInit } from '@angular/core';
import { Cookie } from 'ng2-cookies';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { AuthenticationService } from '../../auth';
import { Globals } from '../../globals';
import { Observable } from 'rxjs';

@Injectable()
export class NewProjectViewService implements OnInit {

    constructor(private http: HttpClient, private authService: AuthenticationService, private globals: Globals) { }

    ngOnInit() : void {
        this.authService.isTokenValid();
    }

     /**
     * Get project by id
     * @param projectId unique id of project
     */
    getProjectById(projectId) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/default-project/' + projectId;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    /**
     * Get all projects
     */
    getAllProjects() : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/default-project/';
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    /**
     * Archives a project
     * @param projectId project unique identifier
     */
    archiveProject(projectId) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/default-project/' + projectId;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.delete(url, {headers: requestHeaders, responseType: 'json'});
    }

    
    /**
     * Delete an attachment belonging to sua
     * @param attachmentId uuid of attachment
     * @param suaId uuid of sua 
     */
    deleteAttachment(attachmentId, suaId) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/import/suaattachment/' + attachmentId + '/' + suaId;

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.delete(url, {headers: requestHeaders, responseType: 'json'});
    }

    restoreArchivedDefaultProject(projectId) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/default-project/restore/' + projectId;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());
        
        return this.http.put(url, null, {headers: requestHeaders, responseType: 'json'});
    }

    getAllSuaRegisterControls(suaId): Observable<any> {        
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/default-registercontrol/sua/' + suaId;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    getParentByChildId(projectId) {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/default-project/parent?childId=' + projectId;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    /**
     * Returns a list of ALL hierarchical children to the the provided project.
     * 
     * @param projectId the uuid of the sua from which to start the search for child projects.  
     */
    getChildrenByProjectId(projectId) {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/default-project/children?projectId=' + projectId;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());
            
        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    /**
     * Get sapo workflow states
     */
    getSapoWorkflow() {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/default-project/sapo/workflow';

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }
}
